import React from 'react';
import { Row, Col, Container } from 'react-bootstrap';
import { Link } from "react-router-dom";

import './Breadcrumbs.styles.css';

const Breadcrumbs = ({ firstProp, secondProp }) => {

  return (
    // <!-- Breadcrumbs -->
    <div className="breadcrumbs">
      <Container>
        <Row>
          <Col xs={12}>
            {/* <ul>
              <li className="home"> <Link to="/" title="Go to Home Page">Home</Link> <span>/</span> </li>
              <li> <Link to="/" title="">Promotions</Link> <span>/ </span> </li>
              <li> <Link to="/" title="">End of Year Sale</Link> <span>/</span> </li>
              <li> <strong>IT &#38; Home Based Learning</strong> </li>
            </ul> */}
          </Col>
        </Row>
      </Container>
    </div>
    // <!-- Breadcrumbs End --> 
  );
};

export default Breadcrumbs;
